import React from 'react';
import { PRICE } from '../data/salesContent';
export function PriceBlock({
  lead
}: {
  lead?: string;
}) {
  return <div className="text-center" data-id="element-43" data-mp="1yua0bo3nuprj">
      {lead && <p className="text-sm font-bold uppercase tracking-[0.2em] text-muted md:text-base" data-id="element-44" data-mp="1yxo1wu4i2uxx">{lead}</p>}
      <p className="mt-1 text-5xl font-black tracking-tight text-ink tabular-nums md:text-6xl" data-id="element-45" data-mp="2csqh67v8lwne">{PRICE}</p>
      <p className="mt-3 text-base text-muted md:text-lg" data-id="element-46" data-mp="27u6pdqtypqn4">Pago único · Acceso digital inmediato</p>
    </div>;
}